const OPEN_CLASS = 'is-open';
const EVENT_NAMESPACE = 'po.';

const PageOverlay = {
  /**
   * Create
   * @param {HTMLFormElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    this.node.querySelector('.js-page-overlay-close').addEventListener('click', () => {
      this.close();
    });

    this.node.querySelector('.js-page-overlay-bg').addEventListener('click', () => {
      this.close();
    });

    window.PageOverlay = {};
    window.PageOverlay.open = this.open.bind(this);
  },

  open(url) {
    const iframe = this.createIframe(url);

    this.node.querySelector('.js-page-overlay-frame').appendChild(iframe);
    this.node.className += ` ${OPEN_CLASS}`;

    window.pubsub.publish(`${EVENT_NAMESPACE}open`, this.node);
  },

  close() {
    this.node.className = this.node.className.replace(` ${OPEN_CLASS}`, '');

    const iframe = this.node.querySelector('iframe');
    iframe.parentNode.removeChild(iframe);

    window.pubsub.publish(`${EVENT_NAMESPACE}close`, this.node);
  },

  createIframe(url) {
    const iframe = document.createElement('iframe');
    const iframeUrl = url.indexOf('?') >= 0 ? `${url}&in_overlay=true` : `${url}?in_overlay=true`;
    iframe.setAttribute('src', iframeUrl);

    return iframe;
  },
};

export default PageOverlay;
